function isExpired(expires) {
  const expirationDate = new Date(expires);
  const now = new Date();
  return now - expirationDate >= 0;
}
const ENV = process.env.NODE_ENV;

function getKey(key) {
  return `${key}_h5_${ENV}`;
}

const _memory = {};
class Storage {
  static get memory() { return _memory; }

  static getItem(key) {
    const storageVal = localStorage.getItem(getKey(key));
    if (storageVal) {
      const data = JSON.parse(storageVal);
      if (data.expires && isExpired(data.expires)) {
        this.removeItem(key);
        return null;
      }
      return data.val;
    }
    return null;
  }

  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      const data = {
        expires: expirationDate && expirationDate.toGMTString(),
        val,
      };
      return localStorage.setItem(getKey(key), JSON.stringify(data));
    }
    return undefined;
  }

  static clear() {
    return localStorage.clear();
  }

  static removeItem(key) {
    return localStorage.removeItem(getKey(key));
  }
}

export default Storage;
